class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
    // Load filtered facets on collection pages to show correct availability counts
    this.loadFilteredFacetsOnInit();
  }

  /**
   * Load filtered facets on initialization to show correct availability counts
   */
  loadFilteredFacetsOnInit() {
    // Only run on collection pages
    if (!window.location.pathname.startsWith('/collections/')) {
      return;
    }

    // Check if availability filter is already applied
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('filter.v.availability')) {
      return; // Already filtered, no need to reload
    }

    // Get the section ID for facets
    const sections = FacetFiltersForm.getSections();
    if (!sections || sections.length === 0) return;

    // Build URL with availability filter
    const currentUrl = window.location.search.slice(1);
    const filteredParams = currentUrl ? `${currentUrl}&filter.v.availability=1` : 'filter.v.availability=1';
    const fetchUrl = `${window.location.pathname}?section_id=${sections[0].section}&${filteredParams}`;

    // Fetch filtered facets
    fetch(fetchUrl)
      .then(response => response.text())
      .then(html => {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        
        // Update only the facet filters, not the product grid
        FacetFiltersForm.renderFilters(html, null);
        
        // Force hide active facets if only availability filter is applied
        FacetFiltersForm.hideAvailabilityOnlyActiveFacets();
      })
      .catch(error => {
        console.error('Failed to load filtered facets:', error);
      });
  }

  /**
   * Hide active facets when only availability filter is applied
   * This prevents showing "Clear All" button for the invisible availability filter
   */
  static hideAvailabilityOnlyActiveFacets() {
    // Check current URL parameters
    const currentParams = new URLSearchParams(window.location.search);
    const filterParams = Array.from(currentParams.keys()).filter(key => key.startsWith('filter.'));
    
    // If only filter.v.availability=1 is present (or no filter params), hide active facets
    const hasOnlyAvailabilityFilter = filterParams.length === 0 || 
      (filterParams.length === 1 && 
       currentParams.has('filter.v.availability') && 
       currentParams.get('filter.v.availability') === '1');
    
    if (hasOnlyAvailabilityFilter) {
      const activeFacetSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
      activeFacetSelectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
          element.classList.add('hidden');
        }
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    FacetFiltersForm.renderSizesWithAvailability(searchParams);
  }

  // REMOVED: renderPageOptimized - using standard renderPage now

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  // REMOVED: All instant rendering functions - using standard Shopify methods now

  static renderSizesWithAvailability(searchParams = "") {
    // This function makes sure that the size-filter-dropdown only inclueds available products
    // Availability is added to the filter when a size is selected in the function onSubmitForm, which means that the frontend is updated when a size is selected
    // This funciton is to update the dropdon on load and whenever a size is not selected.

    let fetchUrl = `${window.location.pathname}?section_id=${FacetFiltersForm.getSections()[0].section}`;
    if(searchParams){
      fetchUrl += `&${searchParams}`;
    } else {
      // If no params are set (On load) use params from url
      fetchUrl += `&${window.location.search.slice(1)}`;
    }

    // Only fetch if no sizes is selected. A size will include filter.v.option in the parameter
    if(!fetchUrl.includes("filter.v.option")){

      // Add availability as parameter
      if(!fetchUrl.includes('filter.v.availability')){
        fetchUrl += '&filter.v.availability=1'
      }

      // Update dropdown
      fetch(fetchUrl)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        // if(document.querySelector(".facets__add-availability-filter") && parsedHTML.querySelector(".facets__add-availability-filter")){
        //   document.querySelector(".facets__add-availability-filter").innerHTML = parsedHTML.querySelector(".facets__add-availability-filter").innerHTML;
        // }
        // if(document.querySelector(".mobile-facets__add-availability-filter") && parsedHTML.querySelector(".mobile-facets__add-availability-filter")){
        //   document.querySelector(".mobile-facets__add-availability-filter").innerHTML = parsedHTML.querySelector(".mobile-facets__add-availability-filter").innerHTML;
        // }
      });
    }
  }

  // REMOVED: renderSizesWithAvailabilityOptimized - not needed with server-side solution

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  // REMOVED: renderProductGridContainerInstant - not needed

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  // REMOVED: renderProductCountInstant - not needed

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  // REMOVED: renderFiltersInstant - not needed

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      
      const activeCount = parseInt(activeFacetsElement.getAttribute('data-active-facets-count'));
      
      // Check if only availability filter is active by examining current search params
      const currentParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev || '');
      const hasOnlyAvailabilityFilter = currentParams.has('filter.v.availability') && 
                                       currentParams.get('filter.v.availability') === '1' &&
                                       Array.from(currentParams.keys()).filter(key => key.startsWith('filter.')).length === 1;
      
      // Hide active facets container if only availability filter is active
      if (activeCount > 0 && !hasOnlyAvailabilityFilter) {
        document.querySelector(selector).classList.remove('hidden');
      } else {
        document.querySelector(selector).classList.add('hidden');
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  // REMOVED: renderActiveFacetsInstant - not needed

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  // REMOVED: renderAdditionalElementsInstant - not needed

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // Clean any phcursor parameters from the URL for better UX
    const cleanParams = FacetFiltersForm.cleanPhcursorFromParams(searchParams);
    history.pushState({ searchParams: cleanParams }, '', `${window.location.pathname}${cleanParams && '?'.concat(cleanParams)}`);
  }

  /**
   * Removes the phcursor parameter from URL search parameters
   * @param {string} searchParams - The search parameters string
   * @returns {string} The cleaned search parameters without phcursor
   */
  static cleanPhcursorFromParams(searchParams) {
    if (!searchParams) return searchParams;
    
    try {
      const urlParams = new URLSearchParams(searchParams);
      urlParams.delete('phcursor');
      return urlParams.toString();
    } catch (error) {
      // Fallback: regex cleanup
      return searchParams.replace(/[?&]phcursor=[^&]*/g, '').replace(/^&/, '');
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    // Ensure availability filter is always included in user interactions
    if (!searchParams.includes('filter.v.availability')) {
      searchParams = searchParams ? `filter.v.availability=1&${searchParams}` : 'filter.v.availability=1';
    }
    
    // Standard form submission with availability filter
    FacetFiltersForm.renderPage(searchParams, event);
  }

  // REMOVED: provideInstantFeedback - not needed with server-side solution

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    const urlParams = new URLSearchParams(url);
    const isClearAll = event.currentTarget.classList.contains('active-facets__button-remove');
    
    // Special handling for "Clear All" button - preserve availability filter
    if (isClearAll) {
      url = 'filter.v.availability=1';
    } else if (!urlParams.has('filter.v.availability')) {
      // For individual filter removals, ensure availability filter is preserved
      if (url) {
        url = 'filter.v.availability=1&' + url;
      } else {
        url = 'filter.v.availability=1';
      }
    }
    
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

// SIMPLIFIED: Removed complex request tracking - using standard Shopify approach

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);